const replaceUrlsFromMap = (reportData, map) => {
  let resp = reportData;

  const DATA_ID_REGEX = /data-id="[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}_\w{2}"/ig;

  const dataIdMatches = resp.match(DATA_ID_REGEX) || [];

  dataIdMatches.forEach((match) => {
    const rawId = match.replace('data-id=', '').replace(/"/ig, '');
    const id = rawId.replace(/[_ts|_hr]/ig, '');
    const rg = new RegExp(`(?:<source data-id="${rawId}"[^>]+src=")([^"]+)`, 'ig');
    resp = resp.replace(rg, `<source data-id="${rawId}" src="${map[id]}"`);
  });

  return resp;
};

export const processVideoUrls = (reportData, testSessionNotes, highlightReels) => {
  const urlMapObj = {};
  if (Array.isArray(testSessionNotes)) {
    testSessionNotes.forEach((tsn) => {
      urlMapObj[tsn.id] = tsn.videoUrl;
    });
  }
  if (Array.isArray(highlightReels)) {
    highlightReels.forEach((hr) => {
      urlMapObj[hr.id] = hr.videoUrl;
    });
  }

  return replaceUrlsFromMap(reportData, urlMapObj);
};
